export default __webpack_public_path__ + "static/media/c001-fsi-3.0916e173.jpg";